<template>
  <div>
    <div class="text-sm font-semibold text-secondary-800 pb-2">{{ $t("securone.scope.title") }}</div>
    <div class="border border-secondary-200 rounded divide-y divide-secondary-100">
      <!-- the wide option is not in the DOM when this actor may not choose it (V5) -->
      <label v-if="wideAllowed" class="flex items-start gap-3 px-4 py-3 cursor-pointer" :class="{ 'bg-secondary-50': value.scope === wide }">
        <input type="radio" class="form-radio mt-1" :checked="value.scope === wide" @change="setScope(wide)" />
        <div>
          <div class="text-sm text-gray-800">{{ $t("securone.scope." + wide) }}</div>
          <div class="text-xs text-gray-500">{{ $t("securone.scope." + wide + "_help") }}</div>
        </div>
      </label>
      <label class="flex items-start gap-3 px-4 py-3 cursor-pointer" :class="{ 'bg-secondary-50': value.scope === 'departments' }">
        <input type="radio" class="form-radio mt-1" :checked="value.scope === 'departments'" @change="setScope('departments')" />
        <div class="flex-1">
          <div class="text-sm text-gray-800">{{ $t("securone.scope.departments") }}</div>
          <div class="text-xs text-gray-500">{{ $t("securone.scope.departments_help") }}</div>
          <DepartmentPicker v-if="value.scope === 'departments'" class="mt-2" :value="value.departmentIds" @input="setDepartments" :departments="departments" />
        </div>
      </label>
    </div>
    <div v-if="help" class="text-xs text-gray-500 mt-2">{{ help }}</div>
  </div>
</template>

<script>
import DepartmentPicker from "./DepartmentPicker.vue";

// Scope selector for groups (global | departments), categories (customer |
// departments) and documents (all_users | customer_only | departments - the
// document level picker composes two of these). v-model is
// { scope, departmentIds }. The wide option renders only when the actor's
// capability allows it: absent, not disabled (plan §7 rule 1).
export default {
  name: "ScopeSelector",
  components: { DepartmentPicker },
  props: {
    value: { type: Object, default: () => ({ scope: "departments", departmentIds: [] }) },
    // 'global' for groups, 'customer' for categories
    wide: { type: String, required: true },
    // store capability that permits the wide option (globalGroup | customerCategory)
    capability: { type: String, required: true },
    help: { type: String, default: "" },
    departments: { type: Array, default: null },
  },
  computed: {
    wideAllowed() {
      return !!this.$store.getters["securone/canWrite"][this.capability];
    },
  },
  methods: {
    setScope(scope) {
      this.$emit("input", { scope, departmentIds: scope === "departments" ? this.value.departmentIds || [] : [] });
    },
    setDepartments(departmentIds) {
      this.$emit("input", { scope: "departments", departmentIds });
    },
  },
  created() {
    // an actor who may not choose the wide scope never starts on it
    if (!this.wideAllowed && this.value.scope !== "departments") this.setScope("departments");
  },
};
</script>
